export var AdminInvocation;
(function (AdminInvocation) {
    AdminInvocation["diagnostics"] = "diagnostics";
    AdminInvocation["debug"] = "rovo";
    // cron
    AdminInvocation["triggerSanityCron"] = "triggerSanityCron";
    AdminInvocation["triggerBroomWagonCron"] = "triggerBroomWagonCron";
})(AdminInvocation || (AdminInvocation = {}));
export var Invocations;
(function (Invocations) {
    // configuration
    Invocations["readConfigurations"] = "readSchedulingConfiguration";
    Invocations["writeConfiguration"] = "writeSchedulingConfiguration";
    Invocations["deleteConfiguration"] = "deleteSchedulingConfiguration";
    // log
    Invocations["log"] = "log";
    Invocations["getUrls"] = "getURLs";
    Invocations["getActivities"] = "getActivities";
    // quick setup
    Invocations["quickSetup"] = "quickSetup";
    // rovo
    // ui-modifications
    Invocations["readUiModifications"] = "getUiModifications";
    Invocations["updateUiModification"] = "updateUiModifications";
    // create / reschedule modals
    Invocations["createOrUpdateIssue"] = "createOrUpdateIssue";
})(Invocations || (Invocations = {}));
export var JsmInvocation;
(function (JsmInvocation) {
    JsmInvocation["getConfiguration"] = "getConfiguration";
    JsmInvocation["getResources"] = "getResources";
    JsmInvocation["getFormFields"] = "getFormFields";
})(JsmInvocation || (JsmInvocation = {}));
export var IssueCheckError;
(function (IssueCheckError) {
    IssueCheckError["MISSING_INFORMATION"] = "MISSING_INFORMATION";
    IssueCheckError["TECHNICAL_ISSUES"] = "TECHNICAL_ISSUES";
    IssueCheckError["CONFLICT"] = "CONFLICT";
    IssueCheckError["NO_CONFLICT"] = "NO_CONFLICT";
})(IssueCheckError || (IssueCheckError = {}));
